



















import SMenu from "./menu";

import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    SMenu,
  },
})
export default class SideMenu extends Vue {
  /**
   * logo
   * @protected
   */
  protected logo: any = require("src/assets/logo.png");

  /**
   * 菜单标题
   * @protected
   * @returns string
   */
  @Prop({ type: String, default: "新保云" })
  protected title: string;

  /**
   * 是否显示菜单
   * @protected
   * @returns boolean
   */
  @Prop({ type: Boolean, default: true })
  protected showTitle: boolean;

  /**
   * 菜单模式
   * @protected
   * @returns string
   */
  @Prop({ type: String, default: "inline" })
  protected mode: string;

  /**
   * 菜单主题
   * @protected
   * @returns string
   */
  @Prop({ type: String, default: "dark" })
  protected theme: string;

  /**
   * 是否可收起
   * @protected
   * @returns boolean
   */
  @Prop({ type: Boolean, default: false })
  protected collapsible: boolean;

  /**
   * 当前菜单收起状态
   * @protected
   * @returns boolean
   */
  @Prop({ type: Boolean, default: false })
  protected collapsed: boolean;

  /**
   * 当前菜单数据
   * @protected
   * @returns boolean
   */
  @Prop({ type: Array, required: true })
  protected menus: Array<any>;

  /**
   * 选择菜单回调
   * @protected
   * @returns void
   */
  protected onSelect(obj: any): void {
    this.$emit("menuSelect", obj);
  }
}
